import { supabase } from "@/lib/supabase/supabaseClient";
import { isEqual, merge } from "lodash";
import { UpdateSurveyProps } from ".";

export const updateSurvey = async ({ data }: UpdateSurveyProps) => {
    if (!data.id) throw new Error("Missing Survey ID");
    const surveyRes = await supabase.from('survey').select('*').eq('id', data.id).single();
    if (surveyRes.error) {
        console.error(surveyRes.error);
        throw new Error("Error fetching survey data");
    }
    const newSurvey = merge({}, surveyRes.data, data);
    const shouldUpdate = !isEqual(surveyRes.data, newSurvey);
    if (!shouldUpdate) throw new Error("No changes in the survey detected");
    return await supabase.from('survey').update(data).eq('id', data.id).select().single();
};
